import React, { ReactNode, useContext } from 'react';
import HeaderContext from './context/HeaderContext';

export interface HeaderMenuButtonProps {
  children: ReactNode;
}

const HeaderMenuButton = ({ children }: HeaderMenuButtonProps): JSX.Element => {
  const { setShowMenu } = useContext(HeaderContext);
  return (
    <button type="button" className="usa-menu-btn" onClick={(): void => setShowMenu(true)}>
      {children}
    </button>
  );
};

export default HeaderMenuButton;
